import React from 'react';
import Cookies from 'js-cookie';
import {
  MenuListItem,
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
  Button,
} from '@deeptrue-frontend/ui';

import { useFormatMessage } from 'components/IntlProvider';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import AUTH from 'consts/auth';

const { connect, actions } = StoreProvider;

const LogoutButton = ({ signOut }: { signOut: () => void }) => {
  const isProduction = process.env.NODE_ENV === 'production';
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const t = useFormatMessage();

  return (
    <>
      <div
        onClick={() => setModalIsOpen(true)}
        style={{ borderTop: '1px solid #ccc' }}
      >
        <MenuListItem title={t('modal.logout.title', 'Log out')}>
          <svg
            focusable="false"
            viewBox="-18 -21 64 64"
            aria-hidden="true"
            role="presentation"
            width="64px"
            height="64px"
          >
            <path
              fill="#353531"
              d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
            ></path>
          </svg>
        </MenuListItem>
      </div>
      <Modal
        isVisible={modalIsOpen}
        onCloseClick={() => setModalIsOpen(false)}
        onBackdropClick={() => setModalIsOpen(false)}
      >
        <ModalTitle>{t('modal.logout.title', 'Logout')}</ModalTitle>
        <ModalContent>
          {t('modal.logout.question', 'Are you sure you want to logout?')}
        </ModalContent>
        <ModalActions justifyContent="space-around">
          <Button variant="outlined" onClick={() => setModalIsOpen(false)}>
            {t('modal.logout.no', 'No')}
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              Cookies.remove(AUTH.TOKEN, {
                path: '/',
                domain: isProduction ? '.deeptrue.com' : 'localhost',
              });
              signOut();
            }}
          >
            {t('modal.logout.yes', 'Yes')}
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};

export default connect(null, {
  signOut: actions.authActions.signOut,
})(LogoutButton);
